const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
};

// API: Get QR code & secret to set up Google Authenticator
const get2FASetupApi = async (
  token: string // Bearer token
): Promise<any> => {
  const url = `${baseURL}/2fa/setup`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Two-factor authentication is already enabled for this account.");
    }

    return await response.json();
  } catch (error) {
    console.error("2FA Setup API Error:", error);
    return Promise.reject(error);
  }
};

export { get2FASetupApi };


const  verify2FACodeApi = async ({
  token,
  code,
}: {
  token: string | null;
  code: string;
}): Promise<{
    [x: string]: any; success: boolean 
}> => {
  const url = `${baseURL}/2fa/verify`;

  const data = new FormData();
  data.append("otp", code);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("2FA API error response:", errorText);
      throw new Error("2FA verification failed.");
    }

    return await response.json();
  } catch (error) {
    console.error("2FA verification error:", error);
    return Promise.reject(error);
  }
};

export { verify2FACodeApi };

const disable2FAApi  = async ({
  token,
  code,
}: {
  token: string | null;
  code: string;
}): Promise<{
    [x: string]: any; success: boolean 
}> => {
  const url = `${baseURL}/2fa/disable`;

  const data = new FormData();
  data.append("otp", code);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Disable 2FA API error:", errorText);
      throw new Error("Failed to disable 2FA");
    }

    return await response.json();
  } catch (error) {
    console.error("2FA disable request failed:", error);
    return Promise.reject(error);
  }
};

export { disable2FAApi  };

const verifyLoginCode  = async ({
  token,
  code,
}: {
  token: string | null;
  code: string;
}): Promise<{
    [x: string]: any; success: boolean 
}> => {
  const url = `${baseURL}/2fa/login-verify`;

  const data = new FormData();
  data.append("otp", code);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Verify 2FA API error:", errorText);
      throw new Error("Failed to Verify 2FA");
    }

    return await response.json();
  } catch (error) {
    console.error("2FA Verify request failed:", error);
    return Promise.reject(error);
  }
};

export { verifyLoginCode  };



